import { FC } from 'react';

import { hasPermission } from '@ravago/shared/next-data-access';
import { FeatureToggle } from '@ravago/shared/page-data/models/config';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';

import { Toggle } from '../../models/feature-permissions.model';

import { ClosedInvoices } from './closed-invoices/closed-invoices';
import { ClosedInvoiceFilters } from './closed-invoices/filters/closed-invoice-filters';
import { OpenInvoiceFilters } from './open-invoices/filters/open-invoice-filters';
import { OpenInvoices } from './open-invoices/open-invoices';

type Props = {
   showOpenInvoices: boolean;
   featureToggles: FeatureToggle[];
};

export const InvoiceOverview: FC<Props> = ({ showOpenInvoices, featureToggles }) => {
   const hasFilterPermissions = hasPermission(featureToggles, Toggle.FILTERS);
   if (showOpenInvoices) {
      return (
         <Box direction="column">
            {hasFilterPermissions && <OpenInvoiceFilters />}
            <OpenInvoices />
         </Box>
      );
   }

   if (!hasPermission(featureToggles, Toggle.CLOSED_INVOICES)) {
      return null;
   }

   return (
      <Box direction="column">
         {hasFilterPermissions && <ClosedInvoiceFilters />}
         <ClosedInvoices />
      </Box>
   );
};
